import React from 'react';
import { Loading, SecondaryButton, TextButton } from '@shape-ds/components';
import { Edit } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useDeleteNotificationMutation } from 'queries/notifications/queries';
import { useGlobalNotification } from 'hooks';
import DeleteIcon from 'assets/icons/delete.svg?react';
import { NotificationItem } from 'queries/notifications/contract';

interface EditModeButtonsProps {
  onEdit: (originalData: NotificationItem) => void;
  notification: NotificationItem;
  editingId?: string;
}

const TableButtons: React.FC<EditModeButtonsProps> = ({ onEdit, notification, editingId }) => {
  const { t } = useTranslation();
  const { displaySnackbar } = useGlobalNotification();
  const { mutate, isLoading } = useDeleteNotificationMutation(() =>
    displaySnackbar({
      type: 'success',
      message: t('messages:delete.message', { item: t('components:notifications.item') }),
    }),
  );
  if (notification.id === editingId) {
    return (
      <>
        <TextButton
          onClick={() => mutate(notification.id)}
          className="notifications-button notifications-button-delete"
        >
          {isLoading ? <Loading size="1rem" /> : <DeleteIcon />}
        </TextButton>
        <SecondaryButton type="submit" className="notifications-button">
          {t('components:notifications.form.buttons.save') as string}
        </SecondaryButton>
      </>
    );
  }
  return (
    <TextButton
      onClick={() => onEdit(notification)}
      data-testid="edit-button"
      className="notifications-button notifications-button-edit"
    >
      <Edit />
    </TextButton>
  );
};

export default TableButtons;
